import React from 'react';

const BuyButton = ({
    label,
    articleNumber,
    quantityFieldId,
    trackingProduct,
    href,
    cssClass,
    onClick,
    labelAndIcon,
    openMiniCartAtCheckout = true
}) => {
    return (
        articleNumber ?
            <a className={cssClass} onClick={() => {
                onClick(articleNumber, quantityFieldId, trackingProduct, openMiniCartAtCheckout)
            }}>
                {labelAndIcon !== null ? 
                    labelAndIcon.icon
                    : <span className="buy-icon"></span>}
                {label}
            </a>
            : <a className={cssClass} href={href}>
                {labelAndIcon !== null ? 
                    labelAndIcon.icon
                    : <span className="buy-icon"></span>}
                {label}
            </a>
    )
}

export default BuyButton;
